module.exports = __webpack_public_path__ + "img/step3_pink.c74f6ec8.png";